import SingleCard from 'app/components/SingleCard/SingleCard';
import { resetAgreementPDFAction, resetFundingStateAction, resetLoanAgreementDocumentAction } from 'app/redux/actions/FundingAction';
import { setNavHeaderVisibleAction } from 'app/redux/actions/NavHeaderAction';
import { RootState } from 'app/redux/store';
import ROUTER_PATH from 'app/routes/routerPath';
import ImagePath from 'app/utilities/imagePath';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './AfterFundingPage.scss';

const AfterFundingPage = function init(): React.ReactElement {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const fundingState = useSelector((state: RootState) => state.fundingReducer);
    const { loanNumber, fundingAmount, error } = fundingState;

    function redirect(path: string): void {
		dispatch(resetLoanAgreementDocumentAction());
		dispatch(resetAgreementPDFAction());
        dispatch(resetFundingStateAction(true));
        navigate({
            pathname: path
        });
    }

    const successFunding = {
        mainText: 'Pendanaan Berhasil',
        subText:
        <>
            Anda telah melakukan pendanaan pada nomor pinjaman
            {' '}
            <b>{loanNumber}</b>
            {' '}
            sebesar
        </>,
        currencyValue: fundingAmount,
        mainButtonText: 'Lihat Dashboard',
        secondButtonText: 'Kembali ke marketplace',
        image: ImagePath.successCheckGif,
        mainTextColor: '#0033A1'
    };

    const failedFunding = {
        mainText: 'Pendanaan Gagal',
        subText:
        <>
            Maaf, pendanaan untuk nomor pinjaman
            {' '}
            <b>{loanNumber}</b>
            {' '}
            belum dapat diproses
        </>,
        currencyValue: null,
        mainButtonText: 'Kembali ke marketplace',
        secondButtonText: '',
        image: ImagePath.failedCheckGif,
        mainTextColor: '#D31800'
    };

    useEffect(() => {
        if (!loanNumber || !fundingAmount) {
            redirect(ROUTER_PATH.marketplace);
        } else {
            dispatch(setNavHeaderVisibleAction(false));
        }
    }, []);

    useEffect(() => () => {
        dispatch(setNavHeaderVisibleAction(true));
    }, []);

    return (
        <div className="after-funding">
            {!error && (
                <SingleCard
                    mainText={successFunding.mainText}
                    subText={successFunding.subText}
                    currencyValue={successFunding.currencyValue}
                    mainButtonText={successFunding.mainButtonText}
                    secondButtonText={successFunding.secondButtonText}
                    image={successFunding.image}
                    mainButtonOnClick={() => redirect(ROUTER_PATH.portofolio)}
                    secondButtonOnClick={() => redirect(ROUTER_PATH.marketplace)}
                    mainTextColor={successFunding.mainTextColor}
                />
            )}
            {error && (
                <SingleCard
                    mainText={failedFunding.mainText}
                    subText={failedFunding.subText}
                    currencyValue={failedFunding.currencyValue}
                    mainButtonText={failedFunding.mainButtonText}
                    secondButtonText={failedFunding.secondButtonText}
                    image={failedFunding.image}
                    mainButtonOnClick={() => redirect(ROUTER_PATH.marketplace)}
                    secondButtonOnClick={() => null}
                    mainTextColor={failedFunding.mainTextColor}
                />
            )}
        </div>
    );
};

export default AfterFundingPage;
